import { Suspense, lazy } from "react";
import type { RouteObject } from "react-router";

import type { DashboardConnectionsDetailsQuery } from "@app_schema";

import type { Breadcrumb } from "@application/types/breadcrumb";

import { DASHBOARD_CONNECTIONS_DETAILS_LOADER } from "@application/loaders/dashboard_connections_details_loader";
import { DASHBOARD_CONNECTIONS_LIST_LOADER } from "@application/loaders/dashboard_connections_list_loader";

import { DASHBOARD_CONNECTIONS_LINK } from "@application/navigation/dashboard_conections_link";

import { Loader } from "@styled/loader";

const DashboardConnectionDetails = lazy(() =>
  import("./connections_details").then((m) => ({
    default: m.DashboardConnectionDetails,
  })),
);
const DashboardConnectionsEdit = lazy(() =>
  import("./connections_edit").then((m) => ({
    default: m.DashboardConnectionsEdit,
  })),
);
const DashboardConnectionsList = lazy(() =>
  import("./connections_list").then((m) => ({
    default: m.DashboardConnectionsList,
  })),
);

export const DASHBOARD_CONNECTIONS_ROUTE = {
  path: "connections",
  handle: DASHBOARD_CONNECTIONS_LINK,
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardConnectionsList />
        </Suspense>
      ),
      loader: DASHBOARD_CONNECTIONS_LIST_LOADER,
    },
    {
      path: ":id",
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardConnectionDetails />
        </Suspense>
      ),
      loader: DASHBOARD_CONNECTIONS_DETAILS_LOADER,
      handle: (data: DashboardConnectionsDetailsQuery): Breadcrumb => ({
        name: data.connection.name,
        to: `/dashboard/connections/${data.connection.id}`,
      }),
    },
    {
      path: ":id/edit",
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardConnectionsEdit />
        </Suspense>
      ),
      loader: DASHBOARD_CONNECTIONS_DETAILS_LOADER,
      handle: (data: DashboardConnectionsDetailsQuery): Breadcrumb => ({
        name: data.connection.name,
        to: `/dashboard/connections/${data.connection.id}/edit`,
      }),
    },
  ],
} satisfies RouteObject;
